import React, { useState } from 'react';
import Line from '../Chart/Line';
import { DateRangePicker } from 'react-dates';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
const CardTransaction = () => {
  const [dateRange, setdateRange] = useState({
    startDate: null,
    endDate: null,
  });
  const [focus, setFocus] = useState(null);

  const { startDate, endDate } = dateRange;

  const handleOnDateChange = ({ startDate, endDate }) =>
    setdateRange({ startDate, endDate });
  return (
    <div className="rounded-lg shadow-sm mb-4">
      <div className="rounded-lg bg-white shadow-lg md:shadow-xl relative overflow-hidden">
        <div className="flex px-8 py-6 border-b border-gray-300 items-center">
          <p className="text-base text-font-gray tracking-0-32">TRANSAKSI</p>
          <div className="px-1 ml-auto">
            <DateRangePicker
              startDatePlaceholderText="Start"
              startDate={startDate}
              onDatesChange={handleOnDateChange}
              endDatePlaceholderText="End"
              endDate={endDate}
              numberOfMonths={1}
              // displayFormat="MMM D"
              showClearDates={true}
              focusedInput={focus}
              onFocusChange={(focus) => setFocus(focus)}
              startDateId="startDateMookh"
              endDateId="endDateMookh"
              minimumNights={0}
            />
          </div>
        </div>
        <div className="flex flex-col px-8 py-6">
          <Line />
        </div>
      </div>
    </div>
  );
};

export default CardTransaction;
